import {ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, ViewRef} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {SwitchBoard} from "../../services/SwitchBoard";
import {LoadingService} from "../../services/LoadingService";
import {MatDialog} from "@angular/material/dialog";
import {ActivatedRoute, Router} from "@angular/router";
import {TaxPlanningService} from "../../tpiq-services/tax-planning.service";
import {QuestionnairesSurveysService} from "../../services/questionnaires-surveys.service";
import {takeUntil} from "rxjs/operators";
import {ToastService} from "../../services/Toast.service";
import {StateService} from "../../services/StateService";
import {NgxScrollEvent} from "../../directives/ngx-scroll-event.directive";
import {TOAST_TYPE} from "../../constants/Tpiq.constants";
import {State} from "../../models/State";
import {PageTitleService} from "../../services/PageTitle";
import {Session} from "../../services/Session";
import {TrackerPaginatedTableComponent} from "../../tables/tracker-paginated-table/tracker-paginated-table.component";
import {TpiqSelectDropdownComponent} from "../../input-search/tpiq-select-dropdown/tpiq-select-dropdown.component";
import {TrackerStylePipe} from "../../pipes/tracker-style.pipe";
import {OrganizersService} from "../../tpiq-services/organizers.service";
import {environment} from "../../../environments/environment";

declare const _: any;
declare let jQuery: any;

@Component({
  selector: 'app-questionnaires-list',
  standalone: true,
  imports: [CommonModule, FormsModule, TrackerPaginatedTableComponent, TpiqSelectDropdownComponent, TrackerStylePipe],
  templateUrl: './questionnaires-list.component.html',
  styleUrl: './questionnaires-list.component.scss'
})
export class QuestionnairesListComponent implements OnInit, OnDestroy {
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  org: any;
  userId: any;
  orgPreferences: any;
  searchObj = {};
  hasOrganizers = false;
  tableData: any = {};
  isLoading = false;
  hasNextSet = false;
  nextIndex = 0;
  organizersSort: any = {};
  organizersTableColumns: Array<any> = [];
  organizersRows: Array<any> = [];

  clientsList: Array<any> = [];
  selectedClients = [];
  selectedClient = [];
  dropDownsList: Array<any> = [];
  qsList: Array<any> = [];
  filterObj: any = {
    questionnaireId: '',
    clientIds: [],
    bucket: []
  };
  allClientsList: Array<any> = [];
  organizersList: Array<any> = [];
  bucketsList: Array<any> = [];
  chunkStatus: Array<any> = [];
  organizerStatuses: Array<any> = [];
  dropdownStatuses: Array<any> = [{id: 'Sent', name: 'Sent'}, {
    id: 'In Progress',
    name: 'In Progress'
  }, {id: 'Submitted', name: 'Submitted'}, {id: 'Locked', name: 'Locked'}, {id: 'Done', name: 'Done'}];
  countData: any = {};
  view = 'Submitted';
  hasCountData = false;
  reveal: any = {
    emailOrganizer: false,
  };
  selectedEmailStatus = '';
  selectedEmailCLientId = '';
  selectedEmailCLientName = '';
  fromDashboard: boolean;
  organizerId = '';
  currentOrganizerName = '';
  copyUrl: string;
  currentEnvironment: any;

  constructor(
    private _router: Router,
    private _route: ActivatedRoute,
    private loadingService: LoadingService,
    private titleService: PageTitleService,
    private stateService: StateService,
    private switchBoard: SwitchBoard,
    private toastService: ToastService,
    private organizersService: OrganizersService,
    private changeDetectorRef: ChangeDetectorRef,
    public dialog: MatDialog,
    private qsService: QuestionnairesSurveysService,
    private taxPlanningService: TaxPlanningService) {
  }

  ngOnInit(): void {
    this._init();
  }

  _init() {
    this.org = Session.getOrg();
    this.userId = Session.getUser().id;
    this.currentEnvironment = environment;
    this.orgPreferences = Session.get('org_Preferences');
    this.getAllClientsList();
    this.switchBoard.onPageChangeListener.next({
      url: this._route.url,
      name: 'Organizers',
      id: "ORGANIZERS"
    });
    const prevState = this.stateService.getPrevState();
    if (prevState && prevState.key === 'organizer') {
      const data = prevState.data;
      this.view = data.view ? data.view : 'sent';
      this.setPageTitle('Questionnaire');
      this.stateService.pop();
      this.loadingService.triggerLoadingEvent(true);
    } else {
      this._route.params.pipe(takeUntil(this.destroy$)).subscribe(params => {
        this.organizerId = params.id;
        this.fromDashboard = true;
        this.setPageTitle('Questionnaire');
        this.switchBoard.onClearSearch.next({});
      });
    }
    this.qsService.getQuestionnaireDetails(this.org, this.userId).subscribe(questionnaire => {
      this.organizerId = questionnaire.questionnaireId;
      this.fromDashboard = true;
      this.setPageTitle('Questionnaire');
      this.bucketsList = questionnaire.buckets;
      const qsList = [{
        questionnaireId: questionnaire.questionnaireId,
        buckets: questionnaire.buckets,
        clients: this.clientsList
      }];
      this.processBucketsList(true, qsList);
      this.switchBoard.onClearSearch.next({});
    }, error => {});
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  processBucketsList(refresh, list, data?){
    const base = this;
    this.qsList = _.cloneDeep(list);
    if (list && list.length > 0) {
      this.dropDownsList = list;
      if (refresh) {
        this.setValues(list);
        this.getQuestionnairesList(true);
      } else {
        if (!_.isEmpty(data)) {
          this.currentOrganizerName = data.currentOrganizerName ? data.currentOrganizerName : '';
          this.setPageTitle(this.currentOrganizerName);
          base.bucketsList = data.bucketsList ? data.bucketsList : '';
          base.clientsList = data.clientsList ? data.clientsList : '';
          base.filterObj.bucket = data.bucket ? data.bucket : '';
          base.filterObj.questionnaireId = data.questionnaireId ? data.questionnaireId : '';
          base.filterObj.clientIds = data.selectedClientFilterObj ? data.selectedClientFilterObj : [];
          base.selectedClients = data.clients ? data.clients : [];
          base.selectedClient = data.selectedClients ? data.selectedClients : [];
          base.organizersSort = data.sort ? data.sort : {};
          base.getQuestionnairesList(true);
        }
      }
    }
  }

  setValues(list) {
    let index = 0;
    this.selectedClient = [];
    this.selectedClients = [];
    this.organizersList = list;
    if (this.fromDashboard) {
      index = _.findIndex(this.organizersList, {questionnaireId: this.organizerId});
      this.setPageTitle("Questionnaire");
    }
    this.bucketsList = this.organizersList[index].buckets;
    this.clientsList = this.organizersList[index].clients;
    this.filterObj = {
      questionnaireId: this.organizersList[index].questionnaireId,
      bucket: this.bucketsList[0] ? this.bucketsList[0].bucketvalue : '',
      clientIds: []
    };
  }

  getAllClientsList() {
    if (Session.getAccessCompanies()) {
      this.setClientsList(Session.getAccessCompanies());
    } else {
      const obj = {
        fromIndex: -1
      };
      this.taxPlanningService.getClients(this.org, this.userId, obj, false)
        .subscribe((response) => {
          this.setClientsList(response.clients);
        }, (error) => {
          this.isLoading = false;
          this.loadingService.triggerLoadingEvent(false);
        });
    }
  }

  setClientsList(clients) {
    const obj = [];
    _.forEach(clients, (value, key) => {
      obj.push({
        clientId: value.id,
        clientName: value.name
      });
    });
    this.allClientsList = obj;
  }

  toggle(view) {
    this.loadingService.triggerLoadingEvent(true);
    this.nextIndex = 0;
    this.view = view;
    this.setPageTitle('Questionnaire');
    this.tableData.rows = [];
    this.getQuestionnairesList(true);
  }

  getQuestionnairesList(refresh) {
    this.fromDashboard = false;
    const request = this.setRequestObj();
    Object.assign(request, this.filterObj);
    if (!_.isEmpty(request)) {
      this.getData(request, refresh);
    }
  }

  setRequestObj() {
    let request: any = {};
    if (this.nextIndex === 0 || this.hasNextSet) {
      const sortObj = this.organizersSort;
      request = this.getSortingObject(sortObj);
      request.fromIndex = this.nextIndex;
      request.status = this.view;
      if (!_.isEmpty(this.searchObj)) {
        request.karlieFilters = _.cloneDeep(this.searchObj);
        const filters = request.karlieFilters;
        if (filters.clients) {
          filters.clients = filters.clients.map(client => client.id);
        }
      }
    }
    return request;
  }

  getData(data, refresh?) {
    this.loadingService.triggerLoadingEvent(true);
    this.getCountData(data);
    this.organizersService.getPaginatedOrganizersList(this.userId, this.org, data).subscribe(response => {
      this.isLoading = false;
      this.organizersTableColumns = response.columns;
      const updatedQuestionnaires = response.questionnaires.map(item => ({
      ...item,
      questionnaireName: item.questionnaireName?.startsWith('TPIQ ')
        ? item.questionnaireName.substring(5)
        : item.questionnaireName
      }));
      // tableData.rows accumulates across pages on infinite scroll, so this has to as well.
      // Replacing it left every earlier-page row unresolvable by the status editor.
      this.organizersRows = refresh ? updatedQuestionnaires : (this.organizersRows || []).concat(updatedQuestionnaires);
      this.buildOrganizerTableData(updatedQuestionnaires, refresh);
      this.nextIndex += response.questionnaires.length;
      this.hasNextSet = response.hasNextPage;
    }, error => {
      // handleScroll set this before dispatching; leaving it true makes the !isLoading guard
      // reject every later scroll, so a single failed page permanently kills pagination.
      this.isLoading = false;
      this.handleError(error);
    });
  }

  getCountData(filters) {
    this.organizersService.getOrganizersCount(this.userId, this.org, filters)
      .subscribe(response => {
        if (response && response.length > 0) {
          this.setBoxesCount(response);
        }
      }, error => {
      });
  }

  getSortingObject(sortObject) {
    const base = this;
    for (const key in sortObject) {
      if (sortObject.hasOwnProperty(key) && sortObject[key]) {
        return {
          sortKey: key,
          sortOrder: sortObject[key],
        };
      }
    }
    return {};
  }

  buildOrganizerTableData(data, refreshTable?) {
    const base = this;
    this.tableData.options = {
      height: '77vh',
      selectorString: 'id',
      showSearch: false,
    };

    this.tableData.columns = [];
    this.tableData.columns = this.formatColumnsForTable(this.organizersTableColumns);
    this.tableData.columns.push({
      name: 'actions',
      title: '',
      type: 'html',
      classes: 'actions-class',
      sortable: false
    });

    if (refreshTable) {
      this.tableData.rows = [];
    } else {
      this.tableData.rows = this.tableData.rows || [];
    }
    const rows = base.tableData.rows || [];

    data.forEach((item) => {
      const row = base.createTableRow(item);
      rows.push(row);
    });

    this.tableData = {...this.tableData, rows};
    this.handleSortOrder(this.organizersSort, this.tableData.columns);

    if (refreshTable) {
      this.hasOrganizers = false;
    }
    this.loadingService.triggerLoadingEvent(false);

    if (base.tableData.rows.length > 0) {
      base.isLoading = false;
    } else {
      base.isLoading = false;
    }
    base.hasOrganizers = true;
  }

  formatColumnsForTable(data) {
    const base = this;
    const colsArray = [];
    let orderArray;
    if (typeof data !== 'string') {
      orderArray = data;
    } else {
      orderArray = JSON.parse(data);
      delete orderArray['Client ID'];
    }
    _.each(Object.keys(orderArray), (key) => {
      if (key === 'Client') {
        colsArray.push({
          name: orderArray[key],
          title: key,
          type: 'html',
          classes: 'pointer zero-overflow',
          sortable: true
        });
      } else if (key === 'Answered') {
        colsArray.push({
          name: orderArray[key],
          title: key,
          type: 'html',
          classes: 'pointer number-css',
          sortable: true
        });
      } else if (key === 'Status') {
        colsArray.push({
          name: orderArray[key],
          title: key,
          classes: 'pointer input-search',
          type: 'badge-input-search',
          'status-col': true,
          editable: true,
          displayName: 'name',
          full_name: 'name',
          background: 'colorCode',
          'multi-dropdown': false,
          data: base.dropdownStatuses,
          placeholder: 'Status',
          sortable: true
        });
      } else {
        colsArray.push({name: orderArray[key], title: key, type: 'normal', sortable: false});
      }
    });
    // Show Status as the last data column — after Sent Date and immediately
    // before the actions/link column the caller appends (CU-868krk6ab #5).
    const statusIdx = colsArray.findIndex((c) => c['status-col']);
    if (statusIdx > -1) {
      const [statusCol] = colsArray.splice(statusIdx, 1);
      colsArray.push(statusCol);
    }
    return colsArray;
  }

  createTableRow(item) {
    const base = this;
    const row: any = {};
    row.selectCol = `<input type='checkbox' class='checkbox'/>`;
    _.each(item, (value, key) => {
      if (key === 'clientName') {
        row.name = item[key];
        // Render the name once. The hidden hover-tooltip span was not being
        // hidden in this table, so it drew the full name a second time
        // ("chris smithchris smith"); use a native title tooltip instead
        // (CU-868kq8c1t). This string is rendered through SafeHtmlPipe
        // (sanitization bypassed), so escape the name in both contexts.
        const fullName = base.escapeHtml(item[key]);
        const shortName = base.escapeHtml(base.setStringSizeLimit(item[key]));
        row[key] = `<a class='actionOnId' data-action='edit' title='${fullName}'><span class='badge-tooltip pointer'>${shortName}</span></a>`;
      } else if (key === 'status') {
        const obj = _.find(base.dropdownStatuses, {id: item[key]});
        if (obj) {
          row[key] = obj;
        } else {
          row[key] = {id: item[key], name: item[key]};
        }
      } else {
        row[key] = item[key];
      }
    });
    row.actions = '';
    if (row.secureLink) {
      row.actions = `<a class="action" data-action="secureLink"><span class="material-icons-outlined me-2 mt-1">link</span></a>`;
    }
    return row;
  }

  setStringSizeLimit(name) {
    if (name && name.length > 40) {
      return name.substring(0, 40) + '....';
    } else {
      return name;
    }
  }

  /** Escape a value for safe interpolation into the table's raw HTML string. */
  escapeHtml(value): string {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  handleSortOrder(sortOrder, columns) {
    _.each(columns, (column) => {
      column.sortType = sortOrder[column.name];
    });
  }

  resetTabData() {
    this.loadingService.triggerLoadingEvent(true);
    this.nextIndex = 0;
    this.isLoading = true;
    this.tableData.rows = [];
    this.getQuestionnairesList(true);
  }

  handleScroll(event: NgxScrollEvent) {
    const base = this;
    if (event.isReachingBottom && !base.isLoading && !event.isWindowEvent && this.hasNextSet) {
      base.isLoading = true;
      this.getQuestionnairesList(false);
    }
  }

  sortByColumn(obj) {
    this.organizersSort[obj.column] = obj.order;
    this.resetSortOrder(this.organizersSort, this.tableData.columns, obj.column);
    this.nextIndex = 0;
    this.getQuestionnairesList(true);
  }

  resetSortOrder(sortOrder, columns, column) {
    _.each(columns, (col) => {
      if (col.name !== column) {
        sortOrder[col.name] = '';
      }
    });
  }

  // Clicking anywhere on an organizer row opens the questionnaire response, same as clicking the client-name link.
  handleRowSelect($event) {
    if (!$event || !$event.clientId || !$event.questionnaireId) {
      return;
    }
    $event.action = 'edit';
    this.handleAction($event);
  }

  handleAction($event) {
    const action = $event.action;
    if (action === 'edit') {
      this.navigateToQuestionnaires($event);
    } else if (action === 'email') {
      this.loadingService.triggerLoadingEvent(true);
      this.resetEmailData();
      this.selectedEmailCLientName = $event.name;
      this.selectedEmailCLientId = $event.clientId;
      this.navigateToEmailList();
    } else if (action === 'secureLink') {
      this.copyLink($event);
    }
  }

  addOrganizerState(email?) {
    const data: any = {
      sort: this.organizersSort,
      view: this.view,
      questionnaireId: this.filterObj.questionnaireId,
      bucket: this.filterObj.bucket,
      clients: this.selectedClients,
      selectedClients: this.selectedClient,
      selectedClientFilterObj: this.filterObj.clientIds,
      bucketsList: this.bucketsList,
      clientsList: this.clientsList,
      currentOrganizerName: this.currentOrganizerName
    };
    if (email) {
      data.emailObj = {
        status: this.selectedEmailStatus ? this.selectedEmailStatus : '',
        questionnaireId: 'All',
        bucket: 'All',
        clientIds: this.selectedEmailCLientId ? [this.selectedEmailCLientId] : [],
        title: this.selectedEmailCLientName ? this.selectedEmailCLientName : this.selectedEmailStatus
      };
    }
    this.stateService.addState(new State('organizer', this._router.url, data, null));
  }

  navigateToQuestionnaires(data) {
    this.addOrganizerState();
    this.titleService.setPageTitle(`${data.name} / ${data.questionnaireName}`);
    const link = ['taxplanningClients', data.clientId, 'questionnaire-response', data.questionnaireId, data.questionnaireName];
    this._router.navigate(link);
  }

  handleError(error) {
    this.loadingService.triggerLoadingEvent(false);
    let message = `Failed To perform operation`;
    try {
      const parsed = typeof error === 'string' ? JSON.parse(error) : error;
      if (parsed && parsed.message) {
        message = parsed.message;
      }
    } catch (e) {
      // Non-JSON body (an HTML error page, for one) still has to reach the user as a toast.
    }
    this.toastService.pop(TOAST_TYPE.error, message);
  }

  setPageTitle(title) {
    this.titleService.setPageTitle(`${title} / ${this.view}`);
  }

  setBoxesCount(response) {
    this.countData = response;
    this.organizerStatuses = _.cloneDeep(response);
    this.dropdownStatuses = _.cloneDeep(response);
    _.forEach(this.dropdownStatuses, (status) => {
      status.name = status.value;
      status.id = status.value;
    });
    this.organizerStatuses.shift();
    if (this.countData.length === 12) {
      const firstChunk = this.countData.slice(0, 3);
      const statuses = this.countData.slice(3, this.countData.length);
      this.chunkStatus = _.chunk(statuses, 3);
      this.chunkStatus.unshift(firstChunk);
    } else if (this.countData.length === 11) {
      const firstChunk = this.countData.slice(0, 2);
      const statuses = this.countData.slice(2, this.countData.length);
      this.chunkStatus = _.chunk(statuses, 3);
      this.chunkStatus.unshift(firstChunk);
    } else if (this.countData.length === 10) {
      const firstChunk = this.countData.slice(0, 2);
      const statuses = this.countData.slice(2, this.countData.length);
      this.chunkStatus = _.chunk(statuses, 3);
      this.chunkStatus.unshift(firstChunk);
    } else if (this.countData.length === 9) {
      const firstChunk = this.countData.slice(0, 2);
      const statuses = this.countData.slice(2, this.countData.length);
      this.chunkStatus = _.chunk(statuses, 3);
      this.chunkStatus.unshift(firstChunk);
    } else if (this.countData.length === 8) {
      const firstChunk = this.countData.slice(0, 2);
      const secondChunk = this.countData.slice(2, 5);
      const statuses = this.countData.slice(5, this.countData.length);
      this.chunkStatus = _.chunk(statuses, 2);
      this.chunkStatus.unshift(secondChunk);
      this.chunkStatus.unshift(firstChunk);
    } else if (this.countData.length === 7) {
      const firstChunk = this.countData.slice(0, 2);
      const secondChunk = this.countData.slice(2, 5);
      const statuses = this.countData.slice(5, this.countData.length);
      this.chunkStatus = _.chunk(statuses, 1);
      this.chunkStatus.unshift(secondChunk);
      this.chunkStatus.unshift(firstChunk);
    } else if (this.countData.length === 6) {
      this.chunkStatus = _.chunk(this.countData, 2);
    } else {
      this.chunkStatus = _.chunk(this.countData, 1);
    }
    this.hasCountData = true;
  }

  // A row is one client + questionnaire + bucket, not one client: a client with more than
  // one bucket has several rows on the page, so clientId alone matches the wrong one.
  // All three fields unconditionally: lodash treats this as a partial matcher, so omitting a
  // falsy bucket would match the first row with the same client and questionnaire whatever
  // its bucket.
  getRowKey(row) {
    return {
      clientId: row.clientId,
      questionnaireId: row.questionnaireId,
      bucket: row.bucket
    };
  }

  // tableData.rows and organizersRows hold different objects for the same row, so each
  // needs its own lookup; an index taken from one does not address the other.
  setRowValue(rowKey, column, value) {
    const rowIndex = _.findIndex(this.tableData.rows, rowKey);
    if (rowIndex !== -1) {
      const rows = this.tableData.rows || [];
      rows[rowIndex][column] = value;
      this.tableData = {...this.tableData, rows};
    }
    const sourceIndex = _.findIndex(this.organizersRows, rowKey);
    if (sourceIndex !== -1) {
      this.organizersRows[sourceIndex][column] = value;
    }
  }

  optionSelected($event) {
    const rowKey = this.getRowKey($event.row);
    const data = _.find(this.organizersRows, rowKey);
    // Revert has to restore what the table renders (a {id, name} object), not the raw
    // string the API row carries, so read the previous value off tableData.rows.
    const previousIndex = _.findIndex(this.tableData.rows, rowKey);
    const previousValue = previousIndex !== -1 ? _.cloneDeep(this.tableData.rows[previousIndex][$event.column]) : undefined;
    if ($event.column === 'status' && data) {
      data[$event.column] = $event.entry;
    }
    const request = {
      status: $event.entry.id,
      bucket: $event.row.bucket
    };
    this.organizersService.updateOnTable(this.org, this.userId, $event.row.clientId, $event.row.questionnaireId, request)
      .subscribe(response => {
        this.toastService.pop(TOAST_TYPE.success, 'Status Updated Successfully');
        this.setRowValue(rowKey, $event.column, $event.entry);
        this.getStatusCount();
      }, error => {
        this.revertSelected($event, previousValue);
        this.handleError(error);
      });
  }

  revertSelected($event, previousValue) {
    if (previousValue === undefined) {
      return;
    }
    this.setRowValue(this.getRowKey($event.row), $event.column, previousValue);
  }

  getStatusCount() {
    const request = this.setRequestObj();
    Object.assign(request, this.filterObj);
    if (!_.isEmpty(request)) {
      this.getCountData(request);
    }
  }

  openEmailReveal(): void {
    this.resetEmailData();
    this.reveal = {...this.reveal, emailOrganizer: true};
    this.invokeChangeDetection();
  }

  invokeChangeDetection() {
    if (!(this.changeDetectorRef as ViewRef).destroyed) {
      this.changeDetectorRef.detectChanges();
    }
  }

  hideReveal(revealFlag) {
    this.reveal[revealFlag] = false;
    if (revealFlag === 'emailOrganizer') {
      this.resetEmailData();
    }
    this.invokeChangeDetection();
  }

  setEmailStatus($event): void {
    if (!_.isEmpty($event)) {
      this.selectedEmailStatus = $event.id;
    } else {
      this.selectedEmailStatus = '';
    }
  }

  validateStatusSelection(): void {
    if (!this.selectedEmailStatus) {
      this.toastService.pop(TOAST_TYPE.warning, 'Select Status');
      return;
    }
    this.navigateToEmailList();
  }

  navigateToEmailList(): void {
    this.addOrganizerState(true);
    this._router.navigate(['organizerEmailList']);
  }

  resetEmailData(): void {
    this.selectedEmailStatus = '';
    this.selectedEmailCLientName = '';
    this.selectedEmailCLientId = '';
  }

  copyLink($event): void {
    const contact = $event.contacts ? $event.contacts[0] : '';
    // Native public form on the firm's own subdomain (CU-868kq8bx5), via the
    // shared helper so this matches the send dialog and the emailed link. The
    // retired forms.taxplaniq.com host is dead.
    this.copyUrl = this.qsService.getPublicFormUrl(this.org, contact.uuid);
    setTimeout( () => {
      jQuery('#secureCopy').select();
      document.execCommand('copy');
      this.toastService.pop(TOAST_TYPE.success, 'URL Copied');
    });
  }

}
